import React from "react";
import styled from "styled-components";


const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoContainer = styled(FlexContainer)`
  padding: 20px;
  gap: 20px;
`;

export const InfoPage = () => {
  const renderReactAppEnvVar = (key) => {
    if (key.startsWith("REACT_APP")){
      return (
        <div>
          <div>{key}:</div>
          <div>{process.env[key]}</div>
          <br />
        </div>
      );
    }
  };

  return (
    <InfoContainer>
      <FlexContainer>
        {Object.keys(process.env).map((key, i) => (
          <div key={i}>
            {renderReactAppEnvVar(key)}
          </div>
        ))}
      </FlexContainer>
    </InfoContainer>
  );
};

InfoPage.propTypes = {};

InfoPage.defaultProps = {};

export default InfoPage;
